export default __webpack_public_path__ + "static/media/salsa-macha.bf0f9ca8.jpg";